

// ===============================================
// before 20-5-2026

// import React, { useState, useEffect, useRef, useMemo } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   IconButton,
//   useTheme,
//   useMediaQuery,
//   TextField,
//   Grid,
//   InputAdornment,
//   Chip,
//   Checkbox,
//   Slide,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Paper,
//   ClickAwayListener,
//   GlobalStyles,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import SearchIcon from '@mui/icons-material/Search';
// import ClearIcon from '@mui/icons-material/Clear';
// import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
// import CheckBoxIcon from '@mui/icons-material/CheckBox';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import UpdateIcon from '@mui/icons-material/Update';
// import GroupIcon from '@mui/icons-material/Group';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import InfoIcon from '@mui/icons-material/Info';
// import { useDispatch, useSelector } from 'react-redux';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import moment from 'moment';

// // استيراد الـ actions
// import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
// import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
// import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
// import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
// import { Get_All_Sales_By_TeamLeader_Email_Action } from '../Redux/Actions/SalesAction';

// // Transition للـ offcanvas من اليمين
// const SlideTransition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="left" ref={ref} {...props} />;
// });

// // أيقونات الـ Checkbox
// const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
// const checkedIcon = <CheckBoxIcon fontSize="small" />;

// // Global styles لضبط z-index للتقويم
// const globalStyles = (
//   <GlobalStyles
//     styles={{
//       '.MuiPickersPopper-root': {
//         zIndex: '999999 !important',
//       },
//       '.MuiPaper-root.MuiPickersPopper-paper': {
//         zIndex: '999999 !important',
//         maxHeight: '400px !important',
//         overflow: 'auto !important',
//       },
//       '.MuiPickersCalendar-root': {
//         maxHeight: '300px !important',
//         minHeight: '280px !important',
//       },
//       '.MuiDayCalendar-monthContainer': {
//         maxHeight: '300px !important',
//         overflow: 'hidden !important',
//       },
//     }}
//   />
// );

// // مكون DatePicker مخصص مع إصلاح مشكلة الظهور
// const CustomDatePicker = ({ label, value, onChange, color = 'primary', ...props }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;

//   const getColor = () => {
//     if (color === 'warning') return mode === 'dark' ? '#ff9800' : '#1976d2';
//     return mode === 'dark' ? '#2196f3' : '#1976d2';
//   };

//   return (
//     <DatePicker
//       label={label}
//       value={value}
//       onChange={onChange}
//       views={['year', 'month', 'day']}
//       slotProps={{
//         textField: {
//           fullWidth: true,
//           size: 'small',
//           sx: {
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//             '& .MuiInputLabel-root': {
//               color: getColor(),
//               '&.Mui-focused': {
//                 color: getColor(),
//               },
//             },
//             '& .MuiOutlinedInput-root': {
//               '&:hover .MuiOutlinedInput-notchedOutline': {
//                 borderColor: getColor(),
//               },
//               '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                 borderColor: getColor(),
//               },
//             },
//           },
//         },
//         popper: {
//           sx: {
//             zIndex: 999999,
//             '& .MuiPaper-root': {
//               zIndex: '999999 !important',
//               maxHeight: '400px',
//               overflow: 'auto',
//             },
//             '& .MuiPickersCalendar-root': {
//               maxHeight: '300px',
//               minHeight: '280px',
//             },
//             '& .MuiDayCalendar-monthContainer': {
//               maxHeight: '300px',
//               minHeight: '280px',
//             },
//             '& .MuiDayCalendar-weekContainer': {
//               height: '36px',
//             },
//             '& .MuiPickersDay-root': {
//               height: '32px',
//               width: '32px',
//               fontSize: '0.875rem',
//             },
//           },
//           disablePortal: false,
//           placement: 'bottom-start',
//           modifiers: [
//             {
//               name: 'preventOverflow',
//               enabled: true,
//               options: {
//                 boundary: 'viewport',
//                 altBoundary: true,
//                 padding: 8,
//               },
//             },
//             {
//               name: 'flip',
//               enabled: true,
//               options: {
//                 fallbackPlacements: ['bottom-start', 'bottom-end', 'top-start', 'top-end'],
//               },
//             },
//           ],
//         },
//         desktopPaper: {
//           sx: {
//             zIndex: 999999,
//             maxHeight: '400px',
//             overflow: 'auto',
//           },
//         },
//       }}
//       {...props}
//     />
//   );
// };

// export const TeamLeaderQuickFilterModal = ({ open, onClose, onApplyFilters }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const dispatch = useDispatch();
//   const [userlogin, setuserlogin] = useState('');

//   // Get User Data
//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem('user'));
//     if (user) {
//       setuserlogin(user);
//     }
//   }, []);

//   const isTeamLeader = userlogin?.data?.role === 'Team Leader';
//   const currentUserId = userlogin?.data?._id;
//   const userEmail = userlogin?.data?.email;

//   // States للفلاتر
//   const [filters, setFilters] = useState({
//     stage: [],
//     project: [],
//     developer: [],
//     chanel: [],
//     campaign: [],
//     createdAt: {
//       from: null,
//       to: null,
//     },
//     stagedateupdated: {
//       from: null,
//       to: null,
//     },
//     // فلتر للـ sales
//     sales: [],
//   });

//   // State للتحكم في القائمة المفتوحة
//   const [openMenu, setOpenMenu] = useState(null);
//   const [searchValue, setSearchValue] = useState('');
//   const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0, width: 0 });

//   // Refs للحقول
//   const fieldRefs = {
//     stage: useRef(null),
//     project: useRef(null),
//     developer: useRef(null),
//     chanel: useRef(null),
//     campaign: useRef(null),
//     sales: useRef(null),
//   };

//   // جلب البيانات من Redux
//   const reschannel = useSelector((state) => state.AllChannalRoot.channal);
//   const resproject = useSelector((state) => state.AllProjects.Projects);
//   const resstages = useSelector((state) => state.Allstages.stage);
//   const resdevelopers = useSelector((state) => state.AllDevelopers.Developers);
//   const rescampaigns = useSelector((state) => state.AllCampaign.campaign);
//   const resGetAllsales = useSelector((state) => state.AllSales.salesforteamleaders);

//   // معالجة البيانات بشكل صحيح
//   const channelarray = Array.isArray(reschannel?.data) ? reschannel.data : [];
//   const projectarray = Array.isArray(resproject?.data) ? resproject.data : [];
//   const stagesarray = Array.isArray(resstages?.data) ? resstages.data : [];
//   const developersarray = Array.isArray(resdevelopers?.data) ? resdevelopers.data : [];
//   const campaignsarray = Array.isArray(rescampaigns?.data) ? rescampaigns.data : [];

//   // معالجة بيانات الـ sales
//   const salesArray = useMemo(() => {
//     if (resGetAllsales?.data) {
//       return Array.isArray(resGetAllsales.data) ? resGetAllsales.data : [];
//     } else if (Array.isArray(resGetAllsales)) {
//       return resGetAllsales;
//     } else {
//       console.log('No sales data found:', resGetAllsales);
//       return [];
//     }
//   }, [resGetAllsales]);

//   // فلترة الـ sales الخاصة بالـ Team Leader فقط
//   const teamLeaderSales = useMemo(() => {
//     if (!salesArray || salesArray.length === 0) return [];

//     return salesArray.filter((sales) => {
//       if (sales?.teamleader?._id) {
//         return sales.teamleader._id === currentUserId;
//       }
//       if (sales?.teamleader) {
//         return sales.teamleader === currentUserId;
//       }
//       return false;
//     });
//   }, [salesArray, currentUserId]);

//   // التحقق إذا كان هناك sales تحت إشراف الـ team leader
//   const hasTeamSales = teamLeaderSales.length > 0;

//   // دالة لجلب الـ sales عند فتح المودال
//   const getallfiltersarray = async () => {
//     try {
//       await dispatch(GetAllchannalData());
//       await dispatch(GetallProjectsdata());
//       await dispatch(GetAll_stage_Data());
//       await dispatch(GetDevelopersData());
//       await dispatch(GetAllCampainData());

//       // جلب الـ sales فقط إذا كان المستخدم team leader
//       if (isTeamLeader && userEmail) {
//         await dispatch(Get_All_Sales_By_TeamLeader_Email_Action(userEmail));
//       }
//     } catch (error) {
//       console.error('Error fetching filter data:', error);
//     }
//   };

//   // جلب البيانات عند فتح المودال
//   useEffect(() => {
//     if (open) {
//       getallfiltersarray();
//     }
//   }, [open, dispatch, userEmail, isTeamLeader]);

//   // دوال التعامل مع الفلاتر
//   const handleFilterChange = (filterType, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       [filterType]: value,
//     }));
//   };

//   const handleDateChange = (dateType, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       createdAt: {
//         ...prev.createdAt,
//         [dateType]: value ? moment(value).format('YYYY-MM-DD') : null,
//       },
//     }));
//   };

//   const handleStageDateChange = (dateType, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       stagedateupdated: {
//         ...prev.stagedateupdated,
//         [dateType]: value ? moment(value).format('YYYY-MM-DD') : null,
//       },
//     }));
//   };

//   const handleItemToggle = (filterType, item) => {
//     setFilters((prev) => {
//       const current = prev[filterType];
//       const isSelected = current.some((i) => getItemId(i) === getItemId(item));

//       if (isSelected) {
//         return {
//           ...prev,
//           [filterType]: current.filter((i) => getItemId(i) !== getItemId(item)),
//         };
//       } else {
//         return {
//           ...prev,
//           [filterType]: [...current, item],
//         };
//       }
//     });
//   };

//   const handleSelectAll = (filterType, options) => {
//     setFilters((prev) => {
//       const current = prev[filterType];
//       if (current.length === options.length) {
//         return {
//           ...prev,
//           [filterType]: [],
//         };
//       } else {
//         return {
//           ...prev,
//           [filterType]: [...options],
//         };
//       }
//     });
//   };

//   const handleOpenMenu = (menuType) => {
//     const fieldRef = fieldRefs[menuType];
//     if (fieldRef.current) {
//       const rect = fieldRef.current.getBoundingClientRect();
//       setAnchorPosition({
//         top: rect.bottom + window.scrollY,
//         left: rect.left + window.scrollX,
//         width: rect.width,
//       });
//       setOpenMenu(menuType);
//       setSearchValue('');
//     }
//   };

//   const handleCloseMenu = () => {
//     setOpenMenu(null);
//     setSearchValue('');
//   };

//   // دالة للحصول على الاسم المعروض
//   const getDisplayName = (item) => {
//     if (typeof item === 'string') return item;
//     return item?.name || item?.CampainName || item?.title || 'Unknown';
//   };

//   // دالة للحصول على اسم الـ sales
//   const getSalesDisplayName = (sales) => {
//     if (typeof sales === 'string') return sales;
//     return (
//       sales?.name || sales?.username || sales?.email || sales?.userlog?.name || 'Unknown Sales'
//     );
//   };

//   // دالة للحصول على الـ ID الفريد للعنصر
//   const getItemId = (item) => {
//     return item?._id || item?.id || item?.name || item?.CampainName || JSON.stringify(item);
//   };

//   // دالة الحصول على sales ID
//   const getSalesId = (sales) => {
//     if (typeof sales === 'string') return sales;
//     return sales?._id || sales?.id || JSON.stringify(sales);
//   };

//   // دالة تطبيق الفلاتر مع إصلاح البحث بأكثر من sales
//   const handleApplyFilters = () => {
//     // تنظيف الفلاتر من القيم الفارغة
//     const cleanedFilters = {
//       ...filters,
//       // إزالة القيم الفارغة من المصفوفات
//       stage: filters.stage.filter((item) => item),
//       project: filters.project.filter((item) => item),
//       developer: filters.developer.filter((item) => item),
//       chanel: filters.chanel.filter((item) => item),
//       campaign: filters.campaign.filter((item) => item),
//       sales: filters.sales.filter((item) => item),
//       // التأكد من صيغة التاريخ
//       createdAt: {
//         from: filters.createdAt.from,
//         to: filters.createdAt.to,
//       },
//       stagedateupdated: {
//         from: filters.stagedateupdated.from,
//         to: filters.stagedateupdated.to,
//       },
//     };

//     console.log('🔍 Applying team leader filters:', cleanedFilters);

//     // ✅ بناء query string
//     const queryParams = new URLSearchParams();

//     // إضافة جميع الحقول المتعددة
//     const multiValueFields = ['stage', 'project', 'developer', 'chanel', 'campaign'];

//     multiValueFields.forEach((field) => {
//       if (cleanedFilters[field] && cleanedFilters[field].length > 0) {
//         cleanedFilters[field].forEach((item) => {
//           const itemId = getItemId(item);
//           if (itemId) {
//             queryParams.append(field, itemId);
//           }
//         });
//       }
//     });

//     // ✅ إضافة sales filter - يمكن إضافة أكثر من sales
//     if (cleanedFilters.sales && cleanedFilters.sales.length > 0) {
//       cleanedFilters.sales.forEach((sales) => {
//         const salesId = getSalesId(sales);
//         if (salesId) {
//           queryParams.append('sales', salesId);
//         }
//       });
//     }

//     // ✅ إضافة التواريخ
//     if (cleanedFilters.createdAt.from) {
//       queryParams.append('createdFrom', cleanedFilters.createdAt.from);
//     }
//     if (cleanedFilters.createdAt.to) {
//       queryParams.append('createdTo', cleanedFilters.createdAt.to);
//     }

//     // إضافة Stage Date Range
//     if (cleanedFilters.stagedateupdated.from) {
//       queryParams.append('stageDateFrom', cleanedFilters.stagedateupdated.from);
//     }
//     if (cleanedFilters.stagedateupdated.to) {
//       queryParams.append('stageDateTo', cleanedFilters.stagedateupdated.to);
//     }

//     const queryString = queryParams.toString();
//     console.log('🔍 Final Query String:', queryString);
//     console.log(
//       '🔍 Selected Sales IDs:',
//       cleanedFilters.sales.map((s) => getSalesId(s)),
//     );

//     onApplyFilters(cleanedFilters, queryString);
//     onClose();
//   };

//   // دالة مسح الفلاتر
//   const handleClearFilters = () => {
//     setFilters({
//       stage: [],
//       project: [],
//       developer: [],
//       chanel: [],
//       campaign: [],
//       createdAt: {
//         from: null,
//         to: null,
//       },
//       stagedateupdated: {
//         from: null,
//         to: null,
//       },
//       sales: [],
//     });
//     handleCloseMenu();
//   };

//   // مكون القائمة المنسدلة
//   const MenuComponent = () => {
//     if (!openMenu) return null;

//     let options = [];
//     let getDisplayFunction = getDisplayName;
//     let getIdFunction = getItemId;

//     switch (openMenu) {
//       case 'stage':
//         options = stagesarray;
//         break;
//       case 'project':
//         options = projectarray;
//         break;
//       case 'developer':
//         options = developersarray;
//         break;
//       case 'chanel':
//         options = channelarray;
//         break;
//       case 'campaign':
//         options = campaignsarray;
//         break;
//       case 'sales':
//         options = teamLeaderSales;
//         getDisplayFunction = getSalesDisplayName;
//         getIdFunction = getSalesId;
//         break;
//       default:
//         options = [];
//     }

//     const selectedItems = filters[openMenu] || [];

//     const filteredOptions = options.filter(
//       (option) =>
//         getDisplayFunction(option).toLowerCase().includes(searchValue.toLowerCase()) ||
//         selectedItems.some((selected) => getIdFunction(selected) === getIdFunction(option)),
//     );

//     const handleItemClick = (item) => {
//       handleItemToggle(openMenu, item);
//     };

//     return (
//       <ClickAwayListener onClickAway={handleCloseMenu}>
//         <Paper
//           sx={{
//             position: 'fixed',
//             top: anchorPosition.top,
//             left: anchorPosition.left,
//             width: anchorPosition.width || 300,
//             maxHeight: 400,
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
//             border: mode === 'dark' ? '1px solid #444' : '1px solid #ddd',
//             boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
//             borderRadius: '8px',
//             overflow: 'hidden',
//             zIndex: 999998,
//           }}
//         >
//           {openMenu === 'sales' && (
//             <Box
//               sx={{
//                 p: 1,
//                 borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}`,
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.05)',
//               }}
//             >
//               <Typography
//                 variant="caption"
//                 sx={{
//                   fontSize: '0.7rem',
//                   color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 0.5,
//                 }}
//               >
//                 <InfoIcon fontSize="inherit" />
//                 {isTeamLeader
//                   ? 'Select sales from your team. You can select multiple sales.'
//                   : 'Select sales for filtering'}
//               </Typography>
//             </Box>
//           )}

//           <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}` }}>
//             <TextField
//               fullWidth
//               size="small"
//               placeholder={`Search ${openMenu}...`}
//               value={searchValue}
//               onChange={(e) => setSearchValue(e.target.value)}
//               autoFocus
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon fontSize="small" />
//                   </InputAdornment>
//                 ),
//                 endAdornment: searchValue && (
//                   <InputAdornment position="end">
//                     <IconButton size="small" onClick={() => setSearchValue('')} edge="end">
//                       <ClearIcon fontSize="small" />
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//                 sx: {
//                   fontSize: '14px',
//                 },
//               }}
//             />
//           </Box>

//           <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}` }}>
//             <Button
//               onClick={() => handleSelectAll(openMenu, options)}
//               size="small"
//               fullWidth
//               sx={{
//                 textTransform: 'none',
//                 fontSize: '0.75rem',
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 justifyContent: 'flex-start',
//                 paddingLeft: 2,
//               }}
//               disabled={openMenu === 'sales' && !hasTeamSales}
//             >
//               {selectedItems.length === options.length ? 'Deselect All' : 'Select All'}
//             </Button>
//           </Box>

//           <List
//             sx={{
//               maxHeight: 300,
//               overflow: 'auto',
//               p: 0,
//             }}
//           >
//             {filteredOptions.length > 0 ? (
//               filteredOptions.map((option, index) => {
//                 const isSelected = selectedItems.some(
//                   (item) => getIdFunction(item) === getIdFunction(option),
//                 );

//                 return (
//                   <ListItem
//                     key={getIdFunction(option) || index}
//                     onClick={() => handleItemClick(option)}
//                     sx={{
//                       py: 1,
//                       px: 2,
//                       cursor: 'pointer',
//                       backgroundColor: isSelected
//                         ? mode === 'dark'
//                           ? 'rgba(25, 118, 210, 0.2)'
//                           : 'rgba(25, 118, 210, 0.1)'
//                         : 'transparent',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                       '&:hover': {
//                         backgroundColor: isSelected
//                           ? mode === 'dark'
//                             ? 'rgba(25, 118, 210, 0.3)'
//                             : 'rgba(25, 118, 210, 0.15)'
//                           : mode === 'dark'
//                             ? 'rgba(255,255,255,0.1)'
//                             : 'rgba(0,0,0,0.04)',
//                       },
//                     }}
//                   >
//                     <ListItemIcon sx={{ minWidth: 40 }}>
//                       <Checkbox
//                         checked={isSelected}
//                         icon={icon}
//                         checkedIcon={checkedIcon}
//                         sx={{
//                           color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                           '&.Mui-checked': {
//                             color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                           },
//                         }}
//                       />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={getDisplayFunction(option)}
//                       primaryTypographyProps={{
//                         fontSize: '14px',
//                         fontWeight: isSelected ? '500' : '400',
//                       }}
//                       secondary={
//                         openMenu === 'sales' && option?.teamleader?.name ? (
//                           <Typography
//                             variant="caption"
//                             color={mode === 'dark' ? '#4caf50' : '#2e7d32'}
//                           >
//                             TL: {option.teamleader.name}
//                           </Typography>
//                         ) : null
//                       }
//                     />
//                   </ListItem>
//                 );
//               })
//             ) : (
//               <ListItem disabled sx={{ justifyContent: 'center', py: 2 }}>
//                 <Typography variant="body2" color="text.secondary">
//                   {openMenu === 'sales' && !hasTeamSales
//                     ? 'No sales assigned to your team'
//                     : 'No options found'}
//                 </Typography>
//               </ListItem>
//             )}
//           </List>
//         </Paper>
//       </ClickAwayListener>
//     );
//   };

//   // مكون حقل الفلتر
//   const FilterField = ({
//     title,
//     filterType,
//     icon: customIcon,
//     placeholder = `Select ${title}...`,
//     disabled = false,
//     helperText = '',
//   }) => {
//     const selectedItems = filters[filterType] || [];
//     const isOpen = openMenu === filterType;

//     const handleClick = () => {
//       if (disabled) return;
//       if (isOpen) {
//         handleCloseMenu();
//       } else {
//         handleOpenMenu(filterType);
//       }
//     };

//     const handleRemoveItem = (item, event) => {
//       event.stopPropagation();
//       if (disabled) return;
//       handleItemToggle(filterType, item);
//     };

//     const getDisplayNameFunction = filterType === 'sales' ? getSalesDisplayName : getDisplayName;

//     return (
//       <Box sx={{ mb: 3 }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, alignItems: 'center' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             {customIcon && customIcon}
//             <Typography
//               sx={{
//                 fontWeight: 600,
//                 color: mode === 'dark' ? '#fff' : '#000',
//                 opacity: disabled ? 0.5 : 1,
//               }}
//             >
//               {title}
//               {filterType === 'sales' && isTeamLeader && (
//                 <Typography
//                   component="span"
//                   variant="caption"
//                   sx={{ ml: 1, color: mode === 'dark' ? '#4caf50' : '#1976d2' }}
//                 >
//                   ({teamLeaderSales.length} available)
//                 </Typography>
//               )}
//             </Typography>
//           </Box>
//         </Box>

//         <Box
//           ref={fieldRefs[filterType]}
//           onClick={handleClick}
//           sx={{
//             border: '1px solid',
//             borderColor: disabled
//               ? mode === 'dark'
//                 ? '#444'
//                 : '#ddd'
//               : isOpen
//                 ? mode === 'dark'
//                   ? '#90caf9'
//                   : '#1976d2'
//                 : mode === 'dark'
//                   ? '#444'
//                   : '#ccc',
//             borderRadius: '4px',
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
//             minHeight: '40px',
//             padding: '8px 12px',
//             cursor: disabled ? 'not-allowed' : 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             '&:hover': {
//               borderColor: disabled
//                 ? mode === 'dark'
//                   ? '#444'
//                   : '#ddd'
//                 : mode === 'dark'
//                   ? '#666'
//                   : '#999',
//             },
//             position: 'relative',
//             outline:
//               isOpen && !disabled ? `2px solid ${mode === 'dark' ? '#90caf9' : '#1976d2'}` : 'none',
//             outlineOffset: '-2px',
//             opacity: disabled ? 0.7 : 1,
//           }}
//         >
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, flex: 1 }}>
//             {selectedItems.length > 0 ? (
//               selectedItems.slice(0, 3).map((item, index) => (
//                 <Chip
//                   key={index}
//                   label={getDisplayNameFunction(item)}
//                   size="small"
//                   onDelete={(e) => handleRemoveItem(item, e)}
//                   sx={{
//                     height: 24,
//                     fontSize: '0.7rem',
//                     backgroundColor: mode === 'dark' ? '#1976d2' : '#e3f2fd',
//                     color: mode === 'dark' ? '#fff' : '#1976d2',
//                     '& .MuiChip-deleteIcon': {
//                       fontSize: '1rem',
//                       color: 'inherit',
//                       '&:hover': {
//                         color: mode === 'dark' ? '#bbdefb' : '#bbdefb',
//                       },
//                     },
//                   }}
//                   disabled={disabled}
//                 />
//               ))
//             ) : (
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: disabled
//                     ? mode === 'dark'
//                       ? 'rgba(255,255,255,0.3)'
//                       : 'rgba(0,0,0,0.3)'
//                     : mode === 'dark'
//                       ? 'rgba(255,255,255,0.5)'
//                       : 'rgba(0,0,0,0.5)',
//                   fontStyle: 'italic',
//                 }}
//               >
//                 {disabled && filterType === 'sales' && !hasTeamSales
//                   ? 'No sales assigned to your team'
//                   : placeholder}
//               </Typography>
//             )}
//             {selectedItems.length > 3 && (
//               <Chip
//                 label={`+${selectedItems.length - 3} more`}
//                 size="small"
//                 sx={{
//                   height: 24,
//                   fontSize: '0.7rem',
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
//                 }}
//               />
//             )}
//           </Box>
//           {!disabled && (
//             <ArrowDropDownIcon
//               sx={{
//                 color: isOpen
//                   ? mode === 'dark'
//                     ? '#90caf9'
//                     : '#1976d2'
//                   : mode === 'dark'
//                     ? '#aaa'
//                     : '#666',
//                 ml: 1,
//                 transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
//                 transition: 'transform 0.2s',
//               }}
//             />
//           )}
//         </Box>

//         {helperText && (
//           <Typography
//             variant="caption"
//             sx={{
//               mt: 0.5,
//               display: 'block',
//               color: mode === 'dark' ? '#aaa' : 'text.secondary',
//               fontStyle: 'italic',
//             }}
//           >
//             {helperText}
//           </Typography>
//         )}

//         {selectedItems.length > 0 && !disabled && (
//           <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//             {selectedItems.map((item, index) => (
//               <Chip
//                 key={index}
//                 label={getDisplayNameFunction(item)}
//                 size="small"
//                 onDelete={(e) => handleRemoveItem(item, e)}
//                 sx={{
//                   height: 24,
//                   fontSize: '0.7rem',
//                   backgroundColor: mode === 'dark' ? '#1976d2' : '#e3f2fd',
//                   color: mode === 'dark' ? '#fff' : '#1976d2',
//                   '& .MuiChip-deleteIcon': {
//                     fontSize: '1rem',
//                     color: 'inherit',
//                     '&:hover': {
//                       color: mode === 'dark' ? '#bbdefb' : '#bbdefb',
//                     },
//                   },
//                 }}
//               />
//             ))}
//           </Box>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <>
//       {globalStyles}
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="md"
//         fullWidth
//         fullScreen={isSmallScreen}
//         TransitionComponent={SlideTransition}
//         style={{ zIndex: '60000' }}
//         PaperProps={{
//           sx: {
//             borderRadius: 0,
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//             backgroundImage: 'none',
//             margin: 0,
//             height: '100vh',
//             width: isSmallScreen ? '100vw' : '500px',
//             maxWidth: '500px !important',
//             position: 'fixed',
//             right: 0,
//             top: 0,
//             bottom: 0,
//             overflow: 'hidden',
//             boxShadow: '0 0 20px rgba(0,0,0,0.3)',
//           },
//         }}
//         sx={{
//           '& .MuiBackdrop-root': {
//             backgroundColor: 'rgba(0, 0, 0, 0.5)',
//           },
//           '& .MuiDialog-container': {
//             overflow: 'hidden',
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             backgroundColor: mode === 'dark' ? 'primary.dark' : 'primary.main',
//             color: 'white',
//             padding: '16px 24px',
//             position: 'sticky',
//             top: 0,
//             zIndex: 9999,
//             boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//             minHeight: '64px',
//           }}
//         >
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <FilterListIcon />
//             <Typography variant="h6" component="span">
//               Team Leader Filter
//               {isTeamLeader && (
//                 <Typography variant="caption" sx={{ ml: 1, opacity: 0.8 }}>
//                   (
//                   {hasTeamSales
//                     ? `${teamLeaderSales.length} sales in your team`
//                     : 'No sales assigned'}
//                   )
//                 </Typography>
//               )}
//             </Typography>
//           </Box>
//           <IconButton onClick={onClose} sx={{ color: 'white' }} size="small">
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent
//           sx={{
//             p: 3,
//             overflow: 'auto',
//             width: '100%',
//             margin: 0,
//             height: 'calc(100vh - 128px)',
//           }}
//         >
//           <LocalizationProvider dateAdapter={AdapterMoment}>
//             <Grid container spacing={3} alignItems="flex-start">
//               <Grid item xs={12}>
//                 {/* Team Leader Sales Filter - يظهر فقط لـ team leaders */}
//                 {isTeamLeader && (
//                   <FilterField
//                     title="My Team Sales"
//                     filterType="sales"
//                     icon={
//                       <GroupIcon
//                         fontSize="small"
//                         sx={{ mr: 0.5, color: mode === 'dark' ? '#4caf50' : '#1976d2' }}
//                       />
//                     }
//                     placeholder="Select sales from your team..."
//                     disabled={!hasTeamSales}
//                     helperText={
//                       !hasTeamSales
//                         ? 'No sales are assigned to your team'
//                         : 'Select one or more sales from your team'
//                     }
//                   />
//                 )}

//                 <FilterField title="Stage" filterType="stage" placeholder="Select Stage..." />

//                 <FilterField title="Project" filterType="project" placeholder="Select Project..." />

//                 <FilterField
//                   title="Developer"
//                   filterType="developer"
//                   placeholder="Select Developer..."
//                 />

//                 <FilterField title="Channel" filterType="chanel" placeholder="Select Channel..." />

//                 <FilterField
//                   title="Campaign"
//                   filterType="campaign"
//                   placeholder="Select Campaign..."
//                 />

//                 {/* Creation Date Range */}
//                 <Box
//                   sx={{
//                     mb: 3,
//                     p: 2,
//                     border: '1px solid',
//                     borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                     borderRadius: 1,
//                     minHeight: '110px',
//                     backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fafafa',
//                   }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                     <CalendarTodayIcon fontSize="small" color="primary" />
//                     <Typography
//                       variant="subtitle1"
//                       gutterBottom
//                       sx={{
//                         fontWeight: '600',
//                         fontSize: '0.95rem',
//                         minHeight: '24px',
//                         lineHeight: '1.2',
//                         color: mode === 'dark' ? '#fff' : '#000',
//                       }}
//                     >
//                       Creation Date Range
//                     </Typography>
//                   </Box>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <CustomDatePicker
//                         label="From Date"
//                         value={filters.createdAt.from ? moment(filters.createdAt.from) : null}
//                         onChange={(date) => handleDateChange('from', date)}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <CustomDatePicker
//                         label="To Date"
//                         value={filters.createdAt.to ? moment(filters.createdAt.to) : null}
//                         onChange={(date) => handleDateChange('to', date)}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {/* Stage Date Range */}
//                 <Box
//                   sx={{
//                     mb: 3,
//                     p: 2,
//                     border: '1px solid',
//                     borderColor: mode === 'dark' ? 'rgba(255,152,0,0.3)' : 'rgba(255,152,0,0.2)',
//                     borderRadius: 1,
//                     minHeight: '110px',
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(255,152,0,0.05)' : 'rgba(255,152,0,0.05)',
//                   }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                     <UpdateIcon fontSize="small" color="warning" />
//                     <Typography
//                       variant="subtitle1"
//                       gutterBottom
//                       sx={{
//                         fontWeight: '600',
//                         fontSize: '0.95rem',
//                         minHeight: '24px',
//                         lineHeight: '1.2',
//                         color: mode === 'dark' ? '#ff9800' : '#1976d2',
//                       }}
//                     >
//                       Stage Date Range
//                     </Typography>
//                   </Box>
//                   <Typography
//                     variant="caption"
//                     color={mode === 'dark' ? '#aaa' : 'text.secondary'}
//                     gutterBottom
//                     sx={{ display: 'block', mb: 2 }}
//                   >
//                     Filter by stage update date (Stage Date Updated)
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <CustomDatePicker
//                         label="Stage Date From"
//                         value={
//                           filters.stagedateupdated.from
//                             ? moment(filters.stagedateupdated.from)
//                             : null
//                         }
//                         onChange={(date) => handleStageDateChange('from', date)}
//                         color="warning"
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <CustomDatePicker
//                         label="Stage Date To"
//                         value={
//                           filters.stagedateupdated.to ? moment(filters.stagedateupdated.to) : null
//                         }
//                         onChange={(date) => handleStageDateChange('to', date)}
//                         color="warning"
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Selected Filters Summary */}
//             {(filters.sales.length > 0 ||
//               Object.values(filters).some((val) =>
//                 Array.isArray(val)
//                   ? val.length > 0
//                   : typeof val === 'object' && val !== null
//                     ? val.from || val.to
//                     : false,
//               )) && (
//               <Box
//                 sx={{
//                   mt: 3,
//                   p: 2,
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(25,118,210,0.1)' : 'rgba(25,118,210,0.05)',
//                   borderRadius: 2,
//                 }}
//               >
//                 <Typography
//                   variant="subtitle2"
//                   gutterBottom
//                   sx={{ fontWeight: 'bold', color: mode === 'dark' ? '#fff' : '#000' }}
//                 >
//                   Selected Filters:
//                 </Typography>
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                   {filters.sales.length > 0 && (
//                     <Chip
//                       label={`Sales: ${filters.sales.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       icon={<GroupIcon />}
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.stage.length > 0 && (
//                     <Chip
//                       label={`Stage: ${filters.stage.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.project.length > 0 && (
//                     <Chip
//                       label={`Project: ${filters.project.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.developer.length > 0 && (
//                     <Chip
//                       label={`Developer: ${filters.developer.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.chanel.length > 0 && (
//                     <Chip
//                       label={`Channel: ${filters.chanel.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.campaign.length > 0 && (
//                     <Chip
//                       label={`Campaign: ${filters.campaign.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {(filters.createdAt.from || filters.createdAt.to) && (
//                     <Chip
//                       label="Creation Date"
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       icon={<CalendarTodayIcon />}
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {(filters.stagedateupdated.from || filters.stagedateupdated.to) && (
//                     <Chip
//                       label="Stage Date"
//                       size="small"
//                       color="warning"
//                       variant="outlined"
//                       icon={<UpdateIcon />}
//                       sx={{ color: mode === 'dark' ? '#ff9800' : '#1976d2' }}
//                     />
//                   )}
//                 </Box>
//               </Box>
//             )}
//           </LocalizationProvider>

//           {openMenu && <MenuComponent />}
//         </DialogContent>

//         <DialogActions
//           sx={{
//             p: 3,
//             gap: 1,
//             borderTop: '1px solid',
//             borderColor: 'divider',
//             position: 'sticky',
//             bottom: 0,
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//           }}
//         >
//           <Button
//             onClick={handleClearFilters}
//             variant="outlined"
//             sx={{
//               color: mode === 'dark' ? '#ffffff' : '#1976d2',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               '&:hover': {
//                 borderColor: mode === 'dark' ? '#ffffff' : '#1976d2',
//               },
//             }}
//           >
//             Clear All
//           </Button>
//           <Box sx={{ flex: 1 }} />
//           <Button
//             onClick={onClose}
//             variant="outlined"
//             sx={{
//               color: mode === 'dark' ? '#ffffff' : '#666',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             onClick={handleApplyFilters}
//             sx={{
//               backgroundColor: '#1976d2',
//               '&:hover': { backgroundColor: '#1565c0' },
//             }}
//           >
//             Apply Filters
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };










// 20-5-2026
import React, { useState, useEffect, useRef, useMemo, useCallback, useLayoutEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Box, Typography, IconButton, useTheme, useMediaQuery,
  Grid, InputAdornment, Chip, Checkbox, Slide,
  List, ListItem, ListItemIcon, ListItemText,
  Paper, ClickAwayListener, GlobalStyles, TextField, Alert, Collapse,
} from '@mui/material';
import CloseIcon            from '@mui/icons-material/Close';
import FilterListIcon       from '@mui/icons-material/FilterList';
import SearchIcon           from '@mui/icons-material/Search';
import ClearIcon            from '@mui/icons-material/Clear';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon         from '@mui/icons-material/CheckBox';
import UpdateIcon           from '@mui/icons-material/Update';
import GroupIcon            from '@mui/icons-material/Group';
import InfoIcon             from '@mui/icons-material/Info';
import { useDispatch, useSelector }         from 'react-redux';
import { LocalizationProvider }             from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment }                    from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker }                       from '@mui/x-date-pickers/DatePicker';
import moment                               from 'moment';

import { GetDevelopersData }                         from '../Redux/Actions/DevelopersAction';
import { GetAllCampainData }                         from '../Redux/Actions/Campaign_Actions';
import { GetAllchannalData }                         from '../Redux/Actions/ChannalActions';
import { GetallProjectsdata }                        from '../Redux/Actions/Projects_Action';
import { GetAll_stage_Data }                         from '../Redux/Actions/Stage_Action';
import { Get_All_Sales_By_TeamLeader_Email_Action }  from '../Redux/Actions/SalesAction';

/* ─── Tokens ─────────────────────────────────────────────────────── */
const ACCENT  = '#0D47A1';
const WARNING = '#F59E0B';

const SlideTransition = React.forwardRef((p, r) => <Slide direction="left" ref={r} {...p} />);
const icon        = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

/* ─── safe array helper ──────────────────────────────────────────── */
const safeArray = (value) => {
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value))       return value;
  return [];
};

/* ─── StableMenu ─────────────────────────────────────────────────── */
const StableMenu = ({
  open, options, selected, searchValue, onSearchChange,
  onToggle, onSelectAll, onClose,
  anchorPosition, mode, textSecondary, inputBg, bg, border,
  getId, getName,
}) => {
  const listRef       = useRef(null);
  const scrollTopRef  = useRef(0);
  const searchRef     = useRef(null);
  const textPrimary   = mode === 'dark' ? '#fff' : '#1a1a2e';

  const safeOptions  = Array.isArray(options)  ? options  : [];
  const safeSelected = Array.isArray(selected) ? selected : [];

  useLayoutEffect(() => {
    if (listRef.current) listRef.current.scrollTop = scrollTopRef.current;
  });

  useEffect(() => {
    if (open && searchRef.current) {
      setTimeout(() => { const i = searchRef.current?.querySelector('input'); i?.focus(); }, 50);
    }
  }, [open]);

  const filtered = safeOptions.filter(opt =>
    getName(opt).toLowerCase().includes((searchValue || '').toLowerCase()) ||
    safeSelected.some(s => getId(s) === getId(opt))
  );

  if (!open) return null;

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Paper sx={{
        position: 'fixed',
        top: anchorPosition.top, left: anchorPosition.left, width: anchorPosition.width,
        maxHeight: 360, bgcolor: bg, border: `1px solid ${border}`,
        borderRadius: '12px', overflow: 'hidden', zIndex: 999999,
        boxShadow: '0 10px 25px -5px rgba(0,0,0,0.15)',
      }}>
        {/* Search */}
        <Box ref={searchRef} sx={{ p: 1.5, borderBottom: `1px solid ${border}` }}>
          <TextField fullWidth size="small" placeholder="Search…" value={searchValue || ''}
            onChange={e => onSearchChange(e.target.value)} autoFocus
            InputProps={{
              startAdornment: <InputAdornment position="start"><SearchIcon sx={{ fontSize: 18, color: textSecondary }} /></InputAdornment>,
              endAdornment: searchValue && <IconButton size="small" onClick={() => onSearchChange('')}><ClearIcon sx={{ fontSize: 16 }} /></IconButton>,
            }}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px', bgcolor: inputBg, '& input': { color: textPrimary } } }}
          />
        </Box>

        {/* Select All */}
        <Box sx={{ px: 1.5, py: 1, borderBottom: `1px solid ${border}` }}>
          <Button size="small" onClick={() => onSelectAll(safeOptions)}
            sx={{ textTransform: 'none', color: ACCENT, fontSize: 12, fontWeight: 500 }}>
            {safeSelected.length === safeOptions.length ? 'Deselect All' : 'Select All'}
          </Button>
        </Box>

        {/* List */}
        <List ref={listRef} onScroll={() => { scrollTopRef.current = listRef.current?.scrollTop || 0; }}
          sx={{ maxHeight: 260, overflow: 'auto', p: 0 }}>
          {filtered.length > 0 ? filtered.map(opt => {
            const sel = safeSelected.some(s => getId(s) === getId(opt));
            return (
              <ListItem key={getId(opt)} onClick={() => onToggle(opt)}
                sx={{ cursor: 'pointer', py: 1.5, '&:hover': { bgcolor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#f5f5f5' } }}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <Checkbox checked={sel} icon={icon} checkedIcon={checkedIcon}
                    sx={{ p: 0, color: textSecondary, '&.Mui-checked': { color: ACCENT } }} />
                </ListItemIcon>
                <ListItemText primary={getName(opt)}
                  primaryTypographyProps={{ fontSize: 13, fontWeight: sel ? 500 : 400, color: textPrimary }} />
              </ListItem>
            );
          }) : (
            <ListItem disabled sx={{ justifyContent: 'center', py: 3 }}>
              <Typography variant="body2" color={textSecondary}>No options found</Typography>
            </ListItem>
          )}
        </List>
      </Paper>
    </ClickAwayListener>
  );
};

/* ─── CustomDatePicker ───────────────────────────────────────────── */
const CustomDatePicker = ({ label, value, onChange, color = 'primary', ...props }) => {
  const mode = useTheme().palette.mode;
  const c = color === 'warning'
    ? (mode === 'dark' ? '#ff9800' : WARNING)
    : (mode === 'dark' ? '#90caf9' : ACCENT);

  return (
    <DatePicker label={label} value={value} onChange={onChange} views={['year', 'month', 'day']}
      slotProps={{
        textField: {
          fullWidth: true, size: 'small',
          sx: {
            bgcolor: mode === 'dark' ? '#2a2a42' : '#f9fafb', borderRadius: '10px',
            '& .MuiInputLabel-root': { color: mode === 'dark' ? '#888' : '#6b7280', fontSize: 13, '&.Mui-focused': { color: c } },
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px',
              '& fieldset': { borderColor: mode === 'dark' ? '#333' : '#e5e7eb' },
              '&:hover fieldset': { borderColor: c },
              '&.Mui-focused fieldset': { borderColor: c, borderWidth: 1 },
            },
          },
        },
        popper: {
          sx: {
            zIndex: '9999999 !important',
            '& .MuiPaper-root': { zIndex: '9999999 !important', marginTop: '8px', borderRadius: '12px', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)' },
            '& .MuiPickersDay-root': { fontSize: 13, width: 36, height: 36, borderRadius: 10 },
          },
          disablePortal: false, placement: 'bottom-start',
          modifiers: [
            { name: 'preventOverflow', enabled: true, options: { boundary: 'viewport', altBoundary: true, padding: 8 } },
            { name: 'flip', enabled: true, options: { fallbackPlacements: ['bottom-start', 'bottom-end', 'top-start'] } },
          ],
        },
      }}
      {...props}
    />
  );
};

/* ════════════════════════════════════════════════════════════════════
   MAIN
════════════════════════════════════════════════════════════════════ */
export const TeamLeaderQuickFilterModal = ({ open, onClose, onApplyFilters, initialFilters }) => {
  const theme         = useTheme();
  const mode          = theme.palette.mode;
  const isSmall       = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch      = useDispatch();

  /* theme tokens */
  const bg          = mode === 'dark' ? '#1a1a2e' : '#ffffff';
  const textPrimary = mode === 'dark' ? '#fff'    : '#1a1a2e';
  const textSec     = mode === 'dark' ? '#888'    : '#6b7280';
  const border      = mode === 'dark' ? '#333'    : '#e5e7eb';
  const inputBg     = mode === 'dark' ? '#2a2a42' : '#f9fafb';

  /* user */
  const [userlogin, setUserlogin] = useState(null);
  useEffect(() => { const u = localStorage.getItem('user'); if (u) setUserlogin(JSON.parse(u)); }, []);

  const isTeamLeader  = userlogin?.data?.role === 'Team Leader';
  const currentUserId = userlogin?.data?._id;
  const userEmail     = userlogin?.data?.email;

  /* filters state */
  const EMPTY = {
    stage: [], project: [], developer: [], chanel: [], campaign: [], sales: [],
    createdAt: { from: null, to: null },
    stagedateupdated: { from: null, to: null },
  };
  const [filters, setFilters] = useState(initialFilters || EMPTY);

  /* menu state */
  const [openMenu,       setOpenMenu]       = useState(null);
  const [searchValue,    setSearchValue]    = useState('');
  const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0, width: 0 });

  /* refs */
  const fieldRefs = {
    stage: useRef(null), project: useRef(null), developer: useRef(null),
    chanel: useRef(null), campaign: useRef(null), sales: useRef(null),
  };

  /* redux — use safeArray everywhere so we never get undefined */
  const reschannel    = useSelector(s => s.AllChannalRoot?.channal);
  const resproject    = useSelector(s => s.AllProjects?.Projects);
  const resstages     = useSelector(s => s.Allstages?.stage);
  const resdevelopers = useSelector(s => s.AllDevelopers?.Developers);
  const rescampaigns  = useSelector(s => s.AllCampaign?.campaign);
  const resGetAllsales = useSelector(s => s.AllSales?.salesforteamleaders);

  const channelarray    = safeArray(reschannel);
  const projectarray    = safeArray(resproject);
  const stagesarray     = safeArray(resstages);
  const developersarray = safeArray(resdevelopers);
  const campaignsarray  = safeArray(rescampaigns);

  const salesArray = useMemo(() => safeArray(resGetAllsales), [resGetAllsales]);

  const teamLeaderSales = useMemo(() => {
    if (!salesArray.length || !currentUserId) return [];
    return salesArray.filter(s => s?.teamleader?._id === currentUserId || s?.teamleader === currentUserId);
  }, [salesArray, currentUserId]);

  const hasTeamSales = teamLeaderSales.length > 0;

  /* helpers */
  const getId  = useCallback(item => item?._id || item?.id || item?.name || item?.CampainName || JSON.stringify(item), []);
  const getName = useCallback(item => {
    if (!item) return 'Unknown';
    if (typeof item === 'string') return item;
    return item?.name || item?.username || item?.email || item?.CampainName || 'Unknown';
  }, []);

  /* fetch */
  useEffect(() => {
    if (!open) return;
    dispatch(GetAllchannalData());
    dispatch(GetallProjectsdata());
    dispatch(GetAll_stage_Data());
    dispatch(GetDevelopersData());
    dispatch(GetAllCampainData());
    if (isTeamLeader && userEmail) dispatch(Get_All_Sales_By_TeamLeader_Email_Action(userEmail));
  }, [open, isTeamLeader, userEmail, dispatch]);

  /* reset when initialFilters changes */
  useEffect(() => { if (initialFilters) setFilters(initialFilters); }, [initialFilters]);

  /* toggle */
  const handleToggle = useCallback((filterType, item) => {
    setFilters(prev => {
      const current = Array.isArray(prev[filterType]) ? prev[filterType] : [];
      return {
        ...prev,
        [filterType]: current.some(i => getId(i) === getId(item))
          ? current.filter(i => getId(i) !== getId(item))
          : [...current, item],
      };
    });
  }, [getId]);

  const handleSelectAll = useCallback((filterType, options) => {
    const safeOpts = Array.isArray(options) ? options : [];
    setFilters(prev => {
      const current = Array.isArray(prev[filterType]) ? prev[filterType] : [];
      return {
        ...prev,
        [filterType]: current.length === safeOpts.length ? [] : [...safeOpts],
      };
    });
  }, []);

  const handleDateChange = (type, field, value) => {
    setFilters(prev => ({ ...prev, [type]: { ...prev[type], [field]: value ? moment(value).format('YYYY-MM-DD') : null } }));
  };

  /* open / close menu */
  const handleOpenMenu = menuType => {
    const ref = fieldRefs[menuType];
    if (ref?.current) {
      const r = ref.current.getBoundingClientRect();
      setAnchorPosition({ top: r.bottom + window.scrollY + 4, left: r.left + window.scrollX, width: r.width });
      setOpenMenu(menuType);
      setSearchValue('');
    }
  };
  const handleCloseMenu = () => { setOpenMenu(null); setSearchValue(''); };

  /* apply */
  const handleApply = () => {
    const q = new URLSearchParams();
    ['stage', 'project', 'developer', 'chanel', 'campaign'].forEach(f => {
      const arr = Array.isArray(filters[f]) ? filters[f] : [];
      arr.filter(Boolean).forEach(item => q.append(f, getId(item)));
    });
    const salesArr = Array.isArray(filters.sales) ? filters.sales : [];
    salesArr.filter(Boolean).forEach(s => q.append('sales', getId(s)));
    if (filters.createdAt?.from)        q.append('createdFrom',  filters.createdAt.from);
    if (filters.createdAt?.to)          q.append('createdTo',    filters.createdAt.to);
    if (filters.stagedateupdated?.from) q.append('stageDateFrom', filters.stagedateupdated.from);
    if (filters.stagedateupdated?.to)   q.append('stageDateTo',   filters.stagedateupdated.to);

    onApplyFilters(filters, q.toString());
    handleCloseMenu();
    onClose();
  };

  const handleClear = () => { setFilters(EMPTY); handleCloseMenu(); };

  /* options per menu */
  const getOptions = m => {
    switch (m) {
      case 'stage':     return stagesarray;
      case 'project':   return projectarray;
      case 'developer': return developersarray;
      case 'chanel':    return channelarray;
      case 'campaign':  return campaignsarray;
      case 'sales':     return teamLeaderSales;
      default: return [];
    }
  };

  /* has filters */
  const hasFilters =
    (filters.stage?.length  > 0) || (filters.project?.length   > 0) ||
    (filters.developer?.length > 0) || (filters.chanel?.length > 0) ||
    (filters.campaign?.length  > 0) || (filters.sales?.length  > 0) ||
    filters.createdAt?.from || filters.createdAt?.to ||
    filters.stagedateupdated?.from || filters.stagedateupdated?.to;

  /* ─── FilterField ─────────────────────────────────────────────── */
  const FilterField = ({ title, filterType, icon: Icon, placeholder, disabled }) => {
    const selected = Array.isArray(filters[filterType]) ? filters[filterType] : [];
    const isOpen   = openMenu === filterType;

    return (
      <Box sx={{ mb: 2.5 }}>
        <Typography sx={{ fontSize: 12, fontWeight: 500, color: textSec, mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {Icon && <Icon sx={{ fontSize: 14, color: ACCENT }} />}
          {title}
          {filterType === 'sales' && isTeamLeader && (
            <Typography component="span" variant="caption" sx={{ ml: 1, color: '#10B981' }}>
              ({teamLeaderSales.length} available)
            </Typography>
          )}
        </Typography>

        <Box
          ref={fieldRefs[filterType]}
          onClick={() => !disabled && (isOpen ? handleCloseMenu() : handleOpenMenu(filterType))}
          sx={{
            border: `1px solid ${isOpen && !disabled ? ACCENT : border}`,
            borderRadius: '10px', bgcolor: disabled ? `${inputBg}80` : inputBg,
            px: 2, py: 1.5, cursor: disabled ? 'not-allowed' : 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            opacity: disabled ? 0.6 : 1,
            transition: 'border-color 0.15s',
            '&:hover': { borderColor: disabled ? border : ACCENT },
          }}
        >
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, flex: 1 }}>
            {selected.length > 0 ? (
              <>
                {selected.slice(0, 2).map((item, i) => (
                  <Chip key={i} label={getName(item)} size="small"
                    onDelete={e => { e.stopPropagation(); if (!disabled) handleToggle(filterType, item); }}
                    sx={{ height: 24, fontSize: 11, borderRadius: '6px', bgcolor: ACCENT, color: '#fff', '& .MuiChip-deleteIcon': { color: '#fff', fontSize: 14 } }} />
                ))}
                {selected.length > 2 && (
                  <Chip label={`+${selected.length - 2}`} size="small"
                    sx={{ height: 24, fontSize: 11, bgcolor: border, color: textSec }} />
                )}
              </>
            ) : (
              <Typography sx={{ fontSize: 13, color: textSec }}>
                {disabled ? 'No sales assigned to your team' : placeholder}
              </Typography>
            )}
          </Box>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
            style={{ transform: isOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s', flexShrink: 0, marginLeft: 8 }}>
            <path d="M6 9L12 15L18 9" stroke={textSec} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Box>
      </Box>
    );
  };

  /* ─── Stage chips ──────────────────────────────────────────────── */
  const StageChip = ({ stage }) => {
    const sel = Array.isArray(filters.stage) && filters.stage.some(s => getId(s) === getId(stage));
    return (
      <Box onClick={() => handleToggle('stage', stage)}
        sx={{
          px: 2, py: 1, borderRadius: '20px', border: `1px solid ${border}`,
          bgcolor: sel ? ACCENT : 'transparent', cursor: 'pointer',
          transition: 'all 0.15s',
          '&:hover': { transform: 'translateY(-1px)', bgcolor: sel ? ACCENT : (mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#f5f5f5') },
        }}>
        <Typography sx={{ fontSize: 12, fontWeight: 500, color: sel ? '#fff' : textPrimary }}>
          {getName(stage)}
        </Typography>
      </Box>
    );
  };

  /* current menu */
  const currentOptions  = openMenu ? getOptions(openMenu) : [];
  const currentSelected = openMenu ? (Array.isArray(filters[openMenu]) ? filters[openMenu] : []) : [];

  /* ─── RENDER ──────────────────────────────────────────────────── */
  return (
    <>
      <GlobalStyles styles={{ '.MuiPickersPopper-root': { zIndex: 999999 }, '.MuiPickersPopper-paper': { zIndex: 999999 } }} />

      <Dialog
        open={open}
        onClose={() => { handleCloseMenu(); onClose(); }}
        fullScreen={isSmall}
        maxWidth="sm" fullWidth
        TransitionComponent={SlideTransition}
        disableEnforceFocus disableAutoFocus
        PaperProps={{
          sx: {
            borderRadius: isSmall ? 0 : '20px', bgcolor: bg,
            margin: isSmall ? 0 : 2,
            height: isSmall ? '100vh' : 'auto', maxHeight: '90vh',
            overflow: 'hidden',
            boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
          },
        }}
        sx={{ zIndex: 60000 }}
      >
        {/* Header */}
        <DialogTitle sx={{ px: 3, py: 2.5, borderBottom: `1px solid ${border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <FilterListIcon sx={{ color: ACCENT, fontSize: 22 }} />
            <Box>
              <Typography sx={{ fontSize: 20, fontWeight: 700, color: textPrimary, letterSpacing: '-0.01em' }}>
                Quick Filter
              </Typography>
              {isTeamLeader && (
                <Typography sx={{ fontSize: 11, color: textSec }}>
                  {hasTeamSales ? `${teamLeaderSales.length} sales in your team` : 'No sales assigned'}
                </Typography>
              )}
            </Box>
          </Box>
          <IconButton onClick={() => { handleCloseMenu(); onClose(); }} size="small">
            <CloseIcon sx={{ color: textSec }} />
          </IconButton>
        </DialogTitle>

        {/* Body */}
        <DialogContent sx={{ p: 3, overflow: 'auto' }}>
          <LocalizationProvider dateAdapter={AdapterMoment}>

            {/* Sales — Team Leader only */}
            {isTeamLeader && (
              <FilterField
                title="My Team Sales"
                filterType="sales"
                icon={GroupIcon}
                placeholder="Select sales from your team…"
                disabled={!hasTeamSales}
              />
            )}

            {/* Stage chips */}
            <Box sx={{ mb: 2.5 }}>
              <Typography sx={{ fontSize: 12, fontWeight: 500, color: textSec, mb: 1 }}>Stage</Typography>
              {stagesarray.length > 0 ? (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {stagesarray.map(s => <StageChip key={getId(s)} stage={s} />)}
                </Box>
              ) : (
                <Box sx={{ border: `1px solid ${border}`, borderRadius: '10px', p: 2, textAlign: 'center', bgcolor: inputBg }}>
                  <Typography sx={{ fontSize: 13, color: textSec }}>Loading stages…</Typography>
                </Box>
              )}
            </Box>

            <FilterField title="Project"   filterType="project"   placeholder="Select Project…" />
            <FilterField title="Developer" filterType="developer" placeholder="Select Developer…" />
            <FilterField title="Channel"   filterType="chanel"    placeholder="Select Channel…" />
            <FilterField title="Campaign"  filterType="campaign"  placeholder="Select Campaign…" />

            {/* Creation Date */}
            <Box sx={{ mb: 2.5 }}>
              <Typography sx={{ fontSize: 12, fontWeight: 500, color: textSec, mb: 1 }}>Creation Date Range</Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CustomDatePicker label="From Date"
                    value={filters.createdAt?.from ? moment(filters.createdAt.from) : null}
                    onChange={d => handleDateChange('createdAt', 'from', d)} />
                </Grid>
                <Grid item xs={6}>
                  <CustomDatePicker label="To Date"
                    value={filters.createdAt?.to ? moment(filters.createdAt.to) : null}
                    onChange={d => handleDateChange('createdAt', 'to', d)} />
                </Grid>
              </Grid>
            </Box>

            {/* Stage Date */}
            <Box sx={{ mb: 2.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <UpdateIcon sx={{ fontSize: 16, color: WARNING }} />
                <Typography sx={{ fontSize: 12, fontWeight: 500, color: textSec }}>Stage Date Range</Typography>
              </Box>
              <Typography variant="caption" sx={{ color: textSec, fontSize: 10, mb: 1, display: 'block' }}>
                Filter by stage update date
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CustomDatePicker label="From Date" color="warning"
                    value={filters.stagedateupdated?.from ? moment(filters.stagedateupdated.from) : null}
                    onChange={d => handleDateChange('stagedateupdated', 'from', d)} />
                </Grid>
                <Grid item xs={6}>
                  <CustomDatePicker label="To Date" color="warning"
                    value={filters.stagedateupdated?.to ? moment(filters.stagedateupdated.to) : null}
                    onChange={d => handleDateChange('stagedateupdated', 'to', d)} />
                </Grid>
              </Grid>
            </Box>

            {/* Summary */}
            {hasFilters && (
              <Box sx={{ mt: 3, p: 2, bgcolor: mode === 'dark' ? 'rgba(13,71,161,0.1)' : 'rgba(13,71,161,0.05)', borderRadius: 2 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: textPrimary, mb: 1, fontSize: 12 }}>
                  Selected Filters:
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {filters.sales?.length > 0      && <Chip label={`Sales: ${filters.sales.length}`}           size="small" sx={{ height: 24, fontSize: 11 }} />}
                  {filters.stage?.length > 0      && <Chip label={`Stage: ${filters.stage.length}`}           size="small" sx={{ height: 24, fontSize: 11 }} />}
                  {filters.project?.length > 0    && <Chip label={`Project: ${filters.project.length}`}       size="small" sx={{ height: 24, fontSize: 11 }} />}
                  {filters.developer?.length > 0  && <Chip label={`Developer: ${filters.developer.length}`}   size="small" sx={{ height: 24, fontSize: 11 }} />}
                  {filters.chanel?.length > 0     && <Chip label={`Channel: ${filters.chanel.length}`}        size="small" sx={{ height: 24, fontSize: 11 }} />}
                  {filters.campaign?.length > 0   && <Chip label={`Campaign: ${filters.campaign.length}`}     size="small" sx={{ height: 24, fontSize: 11 }} />}
                  {(filters.createdAt?.from || filters.createdAt?.to) && (
                    <Chip label="Creation Date Range" size="small" sx={{ height: 24, fontSize: 11 }} />
                  )}
                  {(filters.stagedateupdated?.from || filters.stagedateupdated?.to) && (
                    <Chip label="Stage Date Range" size="small" icon={<UpdateIcon />} sx={{ height: 24, fontSize: 11 }} />
                  )}
                </Box>
              </Box>
            )}

          </LocalizationProvider>
        </DialogContent>

        {/* Footer */}
        <DialogActions sx={{ px: 3, py: 2.5, borderTop: `1px solid ${border}`, gap: 2 }}>
          <Button onClick={handleClear}
            sx={{ color: textSec, textTransform: 'none', fontWeight: 500, fontSize: 13, '&:hover': { bgcolor: 'transparent', color: ACCENT } }}>
            CLEAR ALL
          </Button>
          <Box sx={{ flex: 1 }} />
          <Button onClick={() => { handleCloseMenu(); onClose(); }}
            sx={{ color: textSec, textTransform: 'none', fontWeight: 500, fontSize: 13, '&:hover': { bgcolor: 'transparent', color: ACCENT } }}>
            Cancel
          </Button>
          <Button onClick={handleApply} variant="contained"
            sx={{ bgcolor: ACCENT, textTransform: 'none', fontWeight: 600, px: 4, borderRadius: '10px', fontSize: 13, boxShadow: 'none', '&:hover': { bgcolor: '#0a3880', boxShadow: 'none' } }}>
            Apply Filters
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dropdown menu */}
      <StableMenu
        open={!!openMenu}
        options={currentOptions}
        selected={currentSelected}
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onToggle={item => handleToggle(openMenu, item)}
        onSelectAll={opts => handleSelectAll(openMenu, opts)}
        onClose={handleCloseMenu}
        anchorPosition={anchorPosition}
        mode={mode}
        textSecondary={textSec}
        inputBg={inputBg}
        bg={bg}
        border={border}
        getId={getId}
        getName={getName}
      />
    </>
  );
};
